import { IPartner, IPartnerFlags } from 'clickNgo/entities/partner/models'
import { IAttachment } from 'clickNgo/models/file'

import { useHasChangesInForm } from './useHasChangesInForm'
import { useInitPartnerEditorSetting } from './useInitPartnerDataFormSetting'
import { useResetFormData } from './useResetFormData'

interface IUseOnbPartnerForm {
  partner: IPartner
  partnerFlags: IPartnerFlags
  partnerAttachments: IAttachment[]
  isDisabled?: boolean
  appSource: string
  onboardingRequestId?: number
}

export const useOnbPartnerForm = ({
  partner,
  partnerAttachments,
  partnerFlags,
  isDisabled,
  onboardingRequestId,
  appSource,
}: IUseOnbPartnerForm) => {
  const { actualData, isLoading, isInactive, doCopyBasicAddress } = useInitPartnerEditorSetting({
    partner,
    partnerAttachments,
    partnerFlags,
    isDisabled,
    source: appSource,
    onboardingRequestId,
  })

  const { isFormChanged } = useHasChangesInForm()

  useResetFormData()

  return { isFormChanged, actualData, isLoading, isInactive, doCopyBasicAddress }
}
